import { useMemo } from "react"
import randomId from "src/utils/randomId"

export const useId = () => useMemo(() => randomId(), [])
